import { complement } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

export const isNotNilNorEmpty = complement(isNilOrEmpty);
